import { ScrollArea, ScrollBar } from '@/components/scroll-area'
import { Team } from '@/models/team'

import { OurTeamCard } from './our-team-card'

interface OurTeamProps {
  members: Team[] | null
}

export function OurTeam({ members }: OurTeamProps) {
  return (
    <div className="space-y-5 xl:space-y-8 2xl:space-y-10">
      <h1 className="title">Nosso time</h1>

      <ScrollArea className="md:overflow-x-hidden">
        <div className="w-[300vw] md:w-auto">
          <div className="flex w-full gap-8 md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
            {members?.map((team) => {
              return <OurTeamCard key={team.team_id} member={team} />
            })}
          </div>
        </div>
        <ScrollBar orientation="horizontal" className="md:hidden" />
      </ScrollArea>
    </div>
  )
}
